import { LOGS_PREFIX } from "core/config";
import integrationSettings from "core/integrationSettings";

const getModuleTimerLabel = (module: string) => `${LOGS_PREFIX} [${module}]`;
const originalLogger = console;

const timedLog = (module: string, ...args: unknown[]): void => {
  const { silentMode } = integrationSettings;
  if (silentMode) {
    return;
  }

  // outputs for example "[CF] [core]: 365.335ms message"
  originalLogger.timeLog(getModuleTimerLabel(module), ...args);
  // restart the timer so that next log shows time since this log
  originalLogger.timeEnd(getModuleTimerLabel(module));
  originalLogger.time(getModuleTimerLabel(module));
};

const makeModuleLogger = (module: string) => {
  originalLogger.time(getModuleTimerLabel(module));
  return (...args: unknown[]) => timedLog(module, ...args);
};

export const coreLogger = makeModuleLogger("core");
export const bulkLogger = makeModuleLogger("bulk");
export const autoblockLogger = makeModuleLogger("autoblock");
export const consentLogger = makeModuleLogger("consent");
export const cookieLogger = makeModuleLogger("cookie");
